import React from 'react'
import { CheckCircle, XCircle, Clock, Ban, AlertTriangle } from 'lucide-react'

const StatusBadge = ({ status, size = 'sm' }) => {
  const configs = {
    active: { label: 'Active', icon: CheckCircle, className: 'badge-success' },
    redeemed: { label: 'Redeemed', icon: CheckCircle, className: 'badge-primary' },
    processing: { label: 'Processing', icon: Clock, className: 'badge-warning' },
    completed: { label: 'Completed', icon: CheckCircle, className: 'badge-success' },
    complete: { label: 'Complete', icon: CheckCircle, className: 'badge-success' },
    failed: { label: 'Failed', icon: XCircle, className: 'badge-error' },
    expired: { label: 'Expired', icon: AlertTriangle, className: 'badge-error' },
    revoked: { label: 'Revoked', icon: Ban, className: 'badge-error' },
    pending: { label: 'Pending', icon: Clock, className: 'badge-warning' },
  }

  const config = configs[status?.toLowerCase()] || { label: status || 'Unknown', icon: AlertTriangle, className: 'bg-gray-100 text-gray-600' }
  const Icon = config.icon
  const sizeMap = { xs: 10, sm: 12, md: 14 }

  return (
    <span className={`${config.className} inline-flex items-center space-x-1 ${status === 'processing' ? 'animate-pulse-slow' : ''}`}>
      <Icon size={sizeMap[size] || 12} />
      <span>{config.label}</span>
    </span>
  )
}

export default StatusBadge
